/* eslint-disable @typescript-eslint/no-explicit-any */
import { Location, LocationPagination } from 'model/location';
import { Action } from 'redux';

export const LOCATION_ERROR = 'location/error';
interface LocationErrorAction extends Action<typeof LOCATION_ERROR> {
    payload: {
        error: string;
    };
}

export const LOCATION_CLEAR_ERROR = 'location/clear_error';
type LocationClearErrorAction = Action<typeof LOCATION_CLEAR_ERROR>;

export const LOCATION_CLEAR_SUCCESS = 'location/clear_success';
type LocationClearSuccessAction = Action<typeof LOCATION_CLEAR_SUCCESS>;

export const LOCATION_RESET = 'location/reset';
type LocationResetAction = Action<typeof LOCATION_RESET>;

export const LOCATION_SAVE_START = 'location/save_start';
type LocationSaveStartAction = Action<typeof LOCATION_SAVE_START>;

export const LOCATION_SAVE_SUCCESS = 'location/save_success';
interface LocationSaveSuccessAction extends Action<typeof LOCATION_SAVE_SUCCESS> {
    payload: {
        location: Location;
    };
}

export const LOCATION_FETCH_START = 'location/fetch_start';
type LocationFetchStartAction = Action<typeof LOCATION_FETCH_START>;

export const LOCATION_FETCH_SUCCESS = 'location/fetch_success';
interface LocationFetchSuccessAction extends Action<typeof LOCATION_FETCH_SUCCESS> {
    payload: {
        location: Location;
    };
}

export const LOCATIONS_FETCH_SUCCESS = 'locations/fetch_success';
interface LocationsFetchSuccessAction extends Action<typeof LOCATIONS_FETCH_SUCCESS> {
    payload: {
        locations: Location[];
        pagination: LocationPagination;
    };
}

export type LocationAction =
    | LocationErrorAction
    | LocationClearErrorAction
    | LocationClearSuccessAction
    | LocationResetAction
    | LocationSaveStartAction
    | LocationSaveSuccessAction
    | LocationFetchStartAction
    | LocationFetchSuccessAction
    | LocationsFetchSuccessAction;
